import "../sass/components/_map.scss";

(function () {
  const MAP_SELECTOR = ".single-object__map__canvas, .contact__map";
  const MAP_ID = "5995eb9877e35105df7be4ef";
  const MARKER_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="23" height="31" viewBox="0 0 23 31" fill="none" aria-hidden="true">
  <path d="M11.503 2.88932C6.69461 2.88932 2.88024 6.72369 2.88024 11.3526C2.88024 14.0975 4.30539 17.4623 6.40719 20.8091C8.1018 23.5058 10.0599 25.9136 11.503 27.5569C12.9461 25.9136 14.8982 23.5118 16.5988 20.8091C18.7006 17.4683 20.1257 14.0975 20.1257 11.3526C20.1257 6.72971 16.3114 2.88932 11.503 2.88932ZM0.00598802 11.3526C0.00598802 5.08039 5.15569 0 11.503 0C17.8503 0 23 5.08039 23 11.3526C23 18.5338 15.8024 27.1416 12.7964 30.4221C12.0898 31.1926 10.9102 31.1926 10.2036 30.4221C7.19761 27.1416 0 18.5338 0 11.3526H0.00598802Z" fill="#E2327D"/>
</svg>`;

  let map = null;
  let marker = null;
  let geocoder = null;
  let mapInitialized = false;
  let mapInitializing = false;
  const geocodeCache = new Map();
  let markerView = null;
  let AdvancedMarkerElement = null;

  document.addEventListener("DOMContentLoaded", function () {
    const mapContainer = document.querySelector(MAP_SELECTOR);

    if (!mapContainer) {
      return;
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !mapInitialized && !mapInitializing) {
            initializeGoogleMaps(observer, entry.target);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "50px",
      }
    );

    observer.observe(mapContainer);
  });

  function isMapsBootstrapReady() {
    return (
      typeof google !== "undefined" &&
      typeof google.maps !== "undefined" &&
      typeof google.maps.importLibrary === "function"
    );
  }

  function initializeGoogleMaps(observer, target) {
    mapInitializing = true;

    if (!isMapsBootstrapReady()) {
      let attempts = 0;
      const maxAttempts = 100;

      const checkGoogleMaps = setInterval(function () {
        attempts++;
        if (isMapsBootstrapReady()) {
          clearInterval(checkGoogleMaps);
          setupMap(observer, target);
        } else if (attempts >= maxAttempts) {
          clearInterval(checkGoogleMaps);
          mapInitializing = false;
          showApiError();
        }
      }, 100);

      return;
    }

    setupMap(observer, target);
  }

  async function setupMap(observer, target) {
    const mapContainer = document.querySelector(MAP_SELECTOR);
    if (!mapContainer) {
      mapInitializing = false;
      return;
    }

    mapContainer.classList.add("loading");
    mapContainer.replaceChildren();

    try {
      const mapsLibrary = await google.maps.importLibrary("maps");
      const markerLibrary = await google.maps.importLibrary("marker");
      const Map = mapsLibrary.Map;
      AdvancedMarkerElement = markerLibrary.AdvancedMarkerElement;

      const zoom = getMapZoom(mapContainer);

      const mapOptions = {
        mapId: MAP_ID,
        zoom: zoom,
        center: { lat: 52.3676, lng: 4.9041 },
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        zoomControl: true,
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_BOTTOM,
        },
        disableDefaultUI: true,
        gestureHandling: "cooperative",
        maxZoom: 18,
        minZoom: 10,
      };

      map = new Map(mapContainer, mapOptions);

      mapContainer.classList.remove("loading");
      mapInitialized = true;
      mapInitializing = false;
      if (observer && target) {
        observer.unobserve(target);
      }

      const objectData = getObjectAddressData();

      if (
        objectData &&
        typeof objectData.lat === "number" &&
        typeof objectData.lng === "number"
      ) {
        const location = { lat: objectData.lat, lng: objectData.lng };
        map.setCenter(location);
        placeMarker(location, objectData.address || "");
      } else if (objectData && objectData.address) {
        geocodeAddress(objectData.address);
      } else {
        showNoAddressMessage();
      }
    } catch (error) {
      mapInitialized = false;
      mapInitializing = false;
      showApiError();
    }
  }

  function getMapZoom(mapContainer) {
    const zoom = parseInt(mapContainer.getAttribute("data-zoom"), 10);

    if (Number.isNaN(zoom)) {
      return 15;
    }

    return zoom;
  }

  function getObjectAddressData() {
    const mapContainer = document.querySelector(MAP_SELECTOR);

    if (mapContainer) {
      const lat = parseFloat(mapContainer.getAttribute("data-lat"));
      const lng = parseFloat(mapContainer.getAttribute("data-lng"));
      const address = mapContainer.getAttribute("data-address") || "";

      if (!Number.isNaN(lat) && !Number.isNaN(lng)) {
        return {
          lat: lat,
          lng: lng,
          address: address,
        };
      }
    }

    const scriptTag = document.querySelector("script[data-object-address]");
    if (scriptTag) {
      try {
        const data = JSON.parse(scriptTag.textContent);
        if (data && data.address && data.address.trim() !== "") {
          return data;
        }
      } catch (e) {
        // Silent error handling
      }
    }

    if (mapContainer) {
      const address = mapContainer.getAttribute("data-address") || "";
      const street = mapContainer.getAttribute("data-street") || "";
      const houseNumber = mapContainer.getAttribute("data-house-number") || "";
      const zipcode = mapContainer.getAttribute("data-zipcode") || "";
      const city = mapContainer.getAttribute("data-city") || "";

      if (address && address.trim() !== "") {
        return {
          address: address,
          street: street,
          houseNumber: houseNumber,
          zipcode: zipcode,
          city: city,
        };
      }
    }

    return null;
  }

  async function geocodeAddress(address) {
    if (!address || !map) {
      return;
    }

    if (!geocoder) {
      const geocodingLibrary = await google.maps.importLibrary("geocoding");
      geocoder = new geocodingLibrary.Geocoder();
    }

    if (geocodeCache.has(address)) {
      const cachedResult = geocodeCache.get(address);
      placeMarker(cachedResult, address);
      map.setCenter(cachedResult);
      return;
    }

    geocoder.geocode({ address: address }, function (results, status) {
      if (status === "OK") {
        const location = results[0].geometry.location;

        geocodeCache.set(address, location);
        map.setCenter(location);
        placeMarker(location, address);
      } else {
        showGeocodingError();
      }
    });
  }

  function createMarkerIcon() {
    return {
      url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(MARKER_SVG),
      scaledSize: new google.maps.Size(23, 31),
      anchor: new google.maps.Point(11.5, 31),
    };
  }

  function createMarkerContent() {
    const markerElement = document.createElement("div");
    markerElement.style.lineHeight = "0";
    markerElement.innerHTML = MARKER_SVG;
    return markerElement;
  }

  function placeLegacyMarker(location, address) {
    marker = new google.maps.Marker({
      position: location,
      map: map,
      title: address,
      icon: createMarkerIcon(),
      optimized: true,
    });
  }

  function placeMarker(location, address) {
    if (marker) {
      marker.map = null;
    }
    if (markerView) {
      markerView.map = null;
    }

    try {
      if (AdvancedMarkerElement) {
        markerView = new AdvancedMarkerElement({
          position: location,
          map: map,
          title: address,
          content: createMarkerContent(),
        });

        marker = markerView;
      } else {
        placeLegacyMarker(location, address);
      }
    } catch (error) {
      placeLegacyMarker(location, address);
    }
  }

  function showApiError() {
    const mapContainer = document.querySelector(MAP_SELECTOR);
    if (!mapContainer) {
      return;
    }

    mapContainer.classList.add("error");
    mapContainer.innerHTML = `
      <div>
        <p>Google Maps kon niet worden geladen</p>
        <p>Controleer de API key instellingen</p>
      </div>
    `;
  }

  function showNoAddressMessage() {
    const mapContainer = document.querySelector(MAP_SELECTOR);
    if (!mapContainer) {
      return;
    }

    mapContainer.classList.add("no-data");
    mapContainer.innerHTML = "<div><p>Geen adresgegevens beschikbaar</p></div>";
  }

  function showGeocodingError() {
    const mapContainer = document.querySelector(MAP_SELECTOR);
    if (!mapContainer) {
      return;
    }

    mapContainer.classList.add("error");
    mapContainer.innerHTML = "<div><p>Kon de locatie niet vinden</p></div>";
  }
})();
